import { TableFilterItem } from '@lib/ui-components';

type DateRangeValue = [Date | null, Date | null];

/**
 * Converts filter objects into query parameters
 * @param {Array} filters - Array of filter objects
 * @param {Object} [initialParams={}] - Initial parameters object to extend
 * @returns {Object} Object containing all query parameters
 */
export const convertFiltersToParams = (filters?: TableFilterItem[], initialParams: Record<string, any> = {}): Record<string, any> => {
  const params = { ...initialParams };

  filters?.forEach((filter) => {
    if (filter.column.type === 'date') {
      const dateValue = filter.value as DateRangeValue;
      if (dateValue[0]) {
        Object.assign(params, {
          [`${filter.column.key}From`]: dateValue[0],
        });
      }
      if (dateValue[1]) {
        Object.assign(params, {
          [`${filter.column.key}To`]: dateValue[1],
        });
      }
    } else {
      Object.assign(params, { [filter.column.key]: filter.value });
    }
  });

  return params;
};
